import { ThreadCommentState } from 'state/comments'

export const getSectionComments = (
    campaignComments: Record<string, ThreadCommentState[]> | null,
    identifiers: string[],
) => {
    const comments: {
        identifier: string
        isFieldExist: boolean
        labelPrefix?: string
        threads: ThreadCommentState[]
    }[] = []
    const identifierSet = new Set(identifiers)

    if (campaignComments) {
        Object.keys(campaignComments).forEach(key => {
            const identifier = key.substring(key.lastIndexOf('_') + 1)
            if (identifierSet.has(identifier)) {
                comments.push({ identifier: key, isFieldExist: true, labelPrefix: '', threads: campaignComments[key] })
            }
        })
    }
    return comments
}

export const scrollSelectedCommentIntoView = (element: Element, position: ScrollLogicalPosition) => {
    element.scrollIntoView({ behavior: 'smooth', block: position })
}
